




































import moment from 'moment';
import * as R from 'ramda';
import Vue from 'vue';

import { getTaskSummary, TaskSummary } from './graphql';

export default Vue.extend({
  apollo: {
    summary: {
      query: getTaskSummary,
      variables() {
        const year = this.selected.year();
        const month = this.selected.month() + 1; // months are 0 indexed
        return { year, month };
      },
    },
  },

  data() {
    return {
      selected: moment(),
      summary: null as TaskSummary[] | null,
    };
  },

  computed: {
    taskAvailable(): { [date: string]: boolean } {
      return R.reduce(
        (acc, e) => {
          acc[e.date] = true;
          return acc;
        },
        {} as { [date: string]: boolean },
        this.summary || [],
      );
    },
  },

  methods: {
    getListData(value: moment.Moment) {
      const date = value.format('YYYY-MM-DD');

      return this.taskAvailable[date] || false;
    },
  },
});
